export default defineNuxtRouteMiddleware(async (to, from) => {
    if (useState('profile').value) {
        return await redirectToAuthUserPage()
    }
})